import { render, staticRenderFns } from "./RecommendedSpecialProductSlider.vue?vue&type=template&id=0a80a9ad&scoped=true&"
import script from "./RecommendedSpecialProductSlider.vue?vue&type=script&lang=js&"
export * from "./RecommendedSpecialProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedSpecialProductSlider.vue?vue&type=style&index=0&id=0a80a9ad&scoped=true&lang=css&"
import style1 from "./RecommendedSpecialProductSlider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a80a9ad",
  null
  
)

export default component.exports